<template>
  <div v-if="isiframe">
  </div>
  <div v-else>
    <v-app-bar flat color="transparent">
      <v-toolbar-title>2021 國際數學日 3.14</v-toolbar-title>
    </v-app-bar>
  </div>
</template>
<script>
export default {
  computed: {
    isiframe(){
      if ( window.location !== window.parent.location ) 
      { 
        return true 
      } else{
        return false
      }
    }
      
  }
}
</script>script